// 快速任务
export default {
    taskSettings: 'настройки задачи',
    targetPointEdit: 'Целевая точкаПравить',
    target: 'Цель',
    performTasks: 'выполнять задачи',
    taskPaused: 'задача приостановлена',
    taskContinues: 'задачи продолжается',
    returnImmediately: 'вернуться немедленно',
    landImmediately: 'немедленно приземлиться',
    pleaseSelectGroup: 'Пожалуйста, выберите группу',
    pleaseSelectTargetPoint: 'Пожалуйста, выберите пункт назначения',
    latestTarget: 'последняя цель',
    pleaseEnterNote: 'Пожалуйста, введите примечание',
    add: 'Добавить к',
    groupSettings: 'Настройки группы',
    groupName: 'имя группы',
    enterUAVname: 'Пожалуйста, введите имя дрона',
    optionalUAV: 'Дополнительный дрон',
    selectedUAV: 'выбранный дрон',
    flightParameters: 'параметры полета',
    trajectory: 'траектория',
    trajectoryOne: 'траектория 1',
    trajectoryTwo: 'траектория 2',
    trajectoryThree: 'траектория 3',
    takeoffAltitude: 'высота взлета',
    maxAltitude: 'максимальная высота',
    speed: 'скорость',
    acceleration: 'ускорение',
    endAction: 'окончание действия',
    landing: 'посадка',
    returnFlight: 'Обратный рейс',
    homing: 'самонаведение',
    refresh: 'обновить',
    mapPickup: 'пикап карты',
    endPickup: 'конец пикапа',
    obtain: 'Получать',
    tip_CBEO: 'не может быть пустым или 0',
    tip_PEANV: 'Пожалуйста, введите числовое значение',
    tip_WVR: 'неправильный диапазон значений',
    tip_TAMB: 'Высота взлета должна быть меньше максимальной высоты',
    tip_PTODP: 'точность до одного десятичного знака',
    tip_wrongFormat: 'неверный формат',
    tip_HCBE: 'высота не может быть пустой',
    tip_HMBA: 'высота должна быть числовым значением',
}